// Activity tracker utility for automatic logout after inactivity

const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds
let activityTimer = null;
let lastActivityTime = null;

// Events that indicate user activity
const activityEvents = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'click'
];

/**
 * Update the last activity time
 */
export const updateActivity = () => {
  lastActivityTime = Date.now();
  localStorage.setItem('lastActivity', lastActivityTime.toString());
};

/**
 * Check if user should be logged out due to inactivity
 */
export const checkInactivity = (onLogout) => {
  const lastActivity = localStorage.getItem('lastActivity');
  
  if (!lastActivity) {
    // No activity recorded, set current time
    updateActivity();
    return;
  }

  const timeSinceLastActivity = Date.now() - parseInt(lastActivity, 10);

  if (timeSinceLastActivity >= INACTIVITY_TIMEOUT) {
    // User has been inactive for 30 minutes or more
    if (onLogout) {
      onLogout();
    }
  }
};

/**
 * Start tracking user activity
 */
export const startActivityTracking = (onLogout) => {
  // Initialize last activity time
  const storedActivity = localStorage.getItem('lastActivity');
  if (storedActivity) {
    lastActivityTime = parseInt(storedActivity, 10);
  } else {
    updateActivity();
  }

  // Add event listeners for user activity
  activityEvents.forEach(event => {
    document.addEventListener(event, updateActivity, true);
  });

  // Check for inactivity every minute
  if (activityTimer) {
    clearInterval(activityTimer);
  }

  activityTimer = setInterval(() => {
    checkInactivity(onLogout);
  }, 60 * 1000); // Check every minute

  // Also check immediately
  checkInactivity(onLogout);
};

/**
 * Stop tracking user activity
 */
export const stopActivityTracking = () => {
  // Remove event listeners
  activityEvents.forEach(event => {
    document.removeEventListener(event, updateActivity, true);
  });

  // Clear interval
  if (activityTimer) {
    clearInterval(activityTimer);
    activityTimer = null;
  }

  // Clear stored activity
  localStorage.removeItem('lastActivity');
  lastActivityTime = null;
};

/**
 * Reset the activity timer (useful after login)
 */
export const resetActivityTracking = () => {
  updateActivity();
};
